// extracted by mini-css-extract-plugin
export default {"gachapon":"Gachapon_gachapon__U1aYs","container":"Gachapon_container__QRkWI","machine-text-container":"Gachapon_machine-text-container__hcYtq","dark":"Gachapon_dark__0eVJZ"};